/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import "./Toaster.module.scss";
import ItwinToaster from "./Toaster";
class ThemedToaster {
    constructor() {
        this._toaster = new ItwinToaster();
    }
    error(localizedText, settings) {
        this._toaster.error(localizedText, settings);
    }
    success(localizedText, settings) {
        this._toaster.success(localizedText, settings);
    }
    info(localizedText, settings) {
        this._toaster.informational(localizedText, settings);
    }
    closeAll() {
        this._toaster.closeAll();
    }
}
export const Toaster = new ThemedToaster();
